<template>
  <section class="panel fading">
    <h1>Add an inscription</h1>
    <div class="text" v-html="text.add_inscription" v-if="$route.name == 'inscription' && text"></div>
    <div class="form">
      <div class="section">
        <template v-if="$route.name == 'get-inscription'">
          <div class="heading">Personal details</div>
          <div class="row">
            <label class="label">Name</label>
            <input class="txt" disabled type="text" v-model="personal_display.name" />
          </div>
          <div class="row">
            <label class="label">Telephone</label>
            <input class="txt" disabled type="text" v-model="personal_display.telephone" />
          </div>
          <div class="row">
            <label class="label">Email</label>
            <input class="txt" disabled type="text" v-model="personal_display.email" />
          </div>
          <div class="row">
            <label class="label">Address</label>
            <input class="txt" disabled type="text" v-model="personal_display.address" />
          </div>
        </template>

        <div class="heading">Funeral</div>
        <div class="row">
          <label>Is the stone required to facilitate a funeral?</label>
          <select :disabled="$route.name == 'get-inscription'" class="txt cbo" v-model="inscription.funeral">
            <option value>Please select...</option>
            <option value="No">No</option>
            <option value="Yes">Yes</option>
          </select>
        </div>
        <template v-if="inscription.funeral == 'Yes'">
          <div class="row">
            <label>Funeral Director</label>
            <input
              :disabled="$route.name == 'get-inscription'"
              class="txt"
              type="text"
              v-model="inscription.funeral_director"
            />
          </div>
          <div class="row">
            <label>Date of funeral</label>
            <input
              :disabled="$route.name == 'get-inscription'"
              class="txt"
              type="date"
              v-model="inscription.funeral_date"
            />
          </div>
        </template>
      </div>
      <div class="section">
        <div class="heading">Memorial</div>
        <div class="row">
          <label>How many names are on the stone?</label>
          <input
            :disabled="$route.name == 'get-inscription'"
            @change="checkNumber"
            class="txt txt-names"
            max="10"
            min="1"
            type="number"
            v-model.number="inscription.names_qty"
          />
        </div>
        <template v-for="count in inscription.names_qty">
          <div :key="count">
            <div class="row name">
              <label>{{ label(count) }} on stone</label>
              <input
                :disabled="$route.name == 'get-inscription'"
                class="txt"
                type="text"
                v-model="inscription.names[count - 1]"
              />
            </div>
            <div class="row">
              <label>Date of death</label>
              <input
                :disabled="$route.name == 'get-inscription'"
                class="txt"
                type="date"
                v-model="inscription.dates[count - 1]"
              />
            </div>
          </div>
        </template>
      </div>
      <div class="section">
        <div class="heading">Burial Ground</div>
        <div class="row">
          <label>Name of burial ground</label>
          <input
            :disabled="$route.name == 'get-inscription'"
            class="txt"
            type="text"
            v-model="inscription.burial_ground"
          />
        </div>
        <div class="row">
          <label>Grave number and section</label>
          <input
            :disabled="$route.name == 'get-inscription'"
            class="txt"
            type="text"
            v-model="inscription.grave_number_section"
          />
        </div>
        <div class="row">
          <label>Colour of stone</label>
          <input
            :disabled="$route.name == 'get-inscription'"
            class="txt"
            type="text"
            v-model="inscription.stone_colour"
          />
        </div>
        <div class="row">
          <label>Shape of stone</label>
          <input
            :disabled="$route.name == 'get-inscription'"
            class="txt"
            type="text"
            v-model="inscription.stone_shape"
          />
        </div>
        <div class="row">
          <label>How to find the stone</label>
          <div class="input">
            <textarea
              :disabled="$route.name == 'get-inscription'"
              class="txt textarea"
              placeholder="enter a description or attach a sketch below"
              v-model="inscription.directions"
            ></textarea>

            <vue-dropzone
              :options="dropzoneOptions"
              @vdropzone-mounted="dzMounted"
              @vdropzone-success="success"
              class="upload"
              id="dropzone"
              ref="dropzone"
              v-if="$route.name == 'inscription'"
            ></vue-dropzone>

            <img
              :src="inscription.directions_image"
              v-if="$route.name == 'get-inscription' && inscription.directions_image"
            />
          </div>
        </div>
      </div>
      <div class="section">
        <div class="heading">New Inscription</div>
        <div class="row">
          <textarea :disabled="$route.name == 'get-inscription'" name="editor1" v-model="inscription.text"></textarea>
        </div>
      </div>
      <div class="section">
        <div class="heading">Receiving your quote</div>
        <div class="row">
          <p>
            We will prepare a layout in the same style as the existing inscription and email this to you along with a
            quotation.
          </p>
        </div>
        <div class="row">
          <label>When would you like to receive your quote?</label>
          <select :disabled="$route.name == 'get-inscription'" class="txt cbo" v-model="inscription.when">
            <option value>Please select...</option>
            <option value="No">Before the funeral</option>
            <option value="Yes">About a week after the funeral</option>
          </select>
        </div>
      </div>
      <div class="section">
        <div class="heading">Anything else we should know?</div>
        <div class="row">
          <textarea
            :disabled="$route.name == 'get-inscription'"
            class="txt full"
            placeholder="Please enter any other notes here"
            v-model="inscription.notes"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="actions">
      <p class="error" v-if="error">
        <font-awesome-icon icon="exclamation-triangle" />
        {{ error }}
      </p>
      <button @click="$router.push('/started')" class="button back">Back</button>
      <button @click="nav" class="button">
        Continue
        <pulse></pulse>
      </button>
    </div>
  </section>
</template>

<script>
import api from "@/services/api"
import Pulse from "@/components/Pulse.vue"
import vue2Dropzone from "vue2-dropzone"
import "vue2-dropzone/dist/vue2Dropzone.min.css"

export default {
  data() {
    return {
      error: "",

      personal_display: {},
      inscription: {
        names_qty: 1,
        names: [],
        dates: [],
        funeral: "",
        when: "",
        text: ""
      },

      dropzoneOptions: {
        url: "/.netlify/functions/image",
        maxFilesize: 2,
        headers: {},
        acceptedFiles: "image/*",
        dictDefaultMessage: "Click here or drag and drop your image",
        resizeWidth: 900
      }
    }
  },
  components: {
    Pulse,
    vueDropzone: vue2Dropzone
  },
  computed: {
    text() {
      return this.$store.state.text
    },
    personal() {
      return this.$store.state.personal
    }
  },
  created() {
    if (this.$route.params.id) {
      api.lambda("get", "get?id=" + this.$route.params.id + "&site_id=" + this.$store.state.site_id).then(res => {
        this.personal_display = res.personal
        this.inscription = res.inscription
        this.initialiseCK()
      })
    } else {
      this.inscription.text = this.$store.state.inscription_text
      this.initialiseCK()
    }
  },
  methods: {
    nav: function() {
      this.error = false
      var error = false

      if (!this.inscription.funeral) error = true
      if (this.inscription.funeral == "Yes") {
        if (!this.inscription.funeral_director) error = true
        if (!this.inscription.funeral_date) error = true
      }

      if (!this.inscription.names_qty) error = true
      if (this.inscription.names_qty) {
        for (var i = 0; i < this.inscription.names_qty; i++) {
          if (!this.inscription.names[i]) error = true
          if (!this.inscription.dates[i]) error = true
        }
      }

      if (!this.inscription.burial_ground) error = true
      if (!this.inscription.grave_number_section) error = true
      if (!this.inscription.stone_colour) error = true
      if (!this.inscription.stone_shape) error = true
      if (!(this.inscription.directions || this.inscription.directions_image)) error = true

      if (
        !this.inscription.text ||
        this.inscription.text == this.$store.state.starter_inscription ||
        this.inscription.text.indexOf(this.$store.state.starter_name) > -1
      )
        error = true

      if (!this.inscription.when) error = true

      if (error) {
        this.error = "Please check all fields have been filled in, thank you"
        return
      }

      if (this.inscription.funeral == "No") {
        this.inscription.funeral_director = ""
        this.inscription.funeral_date = ""
      }
      this.inscription.names = this.inscription.names.slice(0, this.inscription.names_qty)
      this.inscription.dates = this.inscription.dates.slice(0, this.inscription.names_qty)
      this.$store.commit("setInscription", this.inscription)

      // api.sendEmail("Adding an inscription to an existing memorial", "")
      this.$router.push("/you")
    },
    checkNumber: function() {
      if (this.names < 1) {
        this.names = 1
      }
    },
    label: function(index) {
      if (this.inscription.names_qty == 1) {
        return "Name"
      } else {
        if (index == 1) {
          return "First name"
        } else {
          if (index == this.inscription.names_qty) {
            return "Last name"
          } else {
            return "Next name"
          }
        }
      }
    },
    success: function(file) {
      var dz = this.$refs.dropzone.dropzone
      if (dz.files[1] != null) dz.removeFile(dz.files[0])

      this.$set(this.inscription, "directions_image", file.dataURL)
      this.$set(this.inscription, "_imageSize", file.size)
      this.$set(this.inscription, "_imageType", file.type)
      this.$set(this.inscription, "_imageName", file.name)
    },
    dzMounted: function() {
      if (this.inscription.directions_image) {
        var dz = this.$refs.dropzone
        dz.manuallyAddFile(
          { size: this.inscription._imageSize, name: this.inscription._imageName, type: this.inscription._imageType },
          this.inscription.directions_image
        )
      }
    },
    initialiseCK() {
      this.$nextTick(() => {
        const ck4Config = {
          extraPlugins: "font,lineheight",
          contentsCss: "/ck/fonts.css",
          fontSize_sizes: "Small/1.2rem;Medium/1.6rem;Large/2rem",
          line_height: "Small/0.8;Medium/1.2;Large/1.6",
          colorButton_colors: "Relief/000,Gold/D4AF37,Silver/BEC2CB",
          colorButton_enableMore: false,
          colorButton_enableAutomatic: false,
          removePlugins: "elementspath,resize",
          height: "40rem",
          font_names: "Goudy Old Style Bold;Zaph Chancery Demi",
          toolbar: [["Font", "FontSize", "lineheight", "TextColor"], ["JustifyCenter"]]
        }
        window.CKEDITOR.plugins.addExternal("lineheight", "/ck/lineheight/plugin.js")
        window.CKEDITOR.replace("editor1", ck4Config)
        window.CKEDITOR.on("instanceReady", () => {
          window.CKEDITOR.instances["editor1"].on("blur", () => {
            let ckeditorData = window.CKEDITOR.instances["editor1"].getData()
            this.inscription.text = ckeditorData
          })
          window.CKEDITOR.instances["editor1"].on("change", () => {
            let ckeditorData = window.CKEDITOR.instances["editor1"].getData()
            this.inscription.text = ckeditorData
          })
        })
      })
    }
  }
}
</script>

<style scoped>
.panel {
  text-align: center;
}
.text {
  max-width: 125rem;
  margin: auto;
}
.form {
  max-width: 80rem;
  margin: auto;
  display: grid;
  margin-top: 5rem;
  text-align: left;
}
.heading {
  max-width: 80rem;
  padding-bottom: 1rem;
  font-family: "Merriweather", serif;
  border-bottom: 1px solid #e7e7e7;
  color: #006654;
  margin-bottom: 2rem;
}
.txt {
  border: 1px solid #e7e7e7;
  border-radius: 0.5rem;
  padding: 1rem 1.5rem;
  width: 60%;
  float: left;
  font-size: 1.5rem;
}
.input {
  float: left;
  width: 60%;
}
.input .txt {
  width: 100%;
}
.name {
  border-top: 1px solid #e7e7e7;
  padding-top: 2rem;
}
.section {
  border: 1px solid #e7e7e7;
  padding: 3rem;
  margin-bottom: 2rem;
  border-radius: 0.5rem;
}
.inputs {
  padding-bottom: 2rem;
}
.row {
  padding-bottom: 2rem;
  display: table;
  width: 100%;
}
.txt-names {
  width: 8rem;
}
.textarea {
  height: 10rem;
}
.full {
  width: 100%;
  height: 15rem;
}
label {
  width: 40%;
  font-size: 1.5rem;
  padding-right: 2rem;
  float: left;
  padding-top: 1rem;
  padding-bottom: 0.5rem;
  line-height: 1.3;
}
.upload {
  border: 0.5rem dashed #f5f5f5;
  padding: 2rem;
  max-width: 50rem;
  margin: auto;
  border-radius: 1rem;
  color: #ccc;
  cursor: pointer;
  font-size: 1.5rem;
  clear: both;
  text-align: center;
}
.input .textarea {
  margin-bottom: 2rem;
}
.txt.cbo {
  width: 40%;
}
.row p {
  font-size: 1.5rem;
}
@media screen and (max-width: 600px) {
  label,
  .input {
    width: 100%;
  }
  .txt {
    margin-left: 0;
    width: 100%;
  }
  .txt-names {
    width: 8rem;
  }
}
</style>
